import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Overlays from '@project/shared/utils/overlays/js/overlays';

const classes = {
	closeButton: 'js-m-favourite-layer__close',
	activeClass: 'state-favourite-popup--visible',
};

@createModule('FavouriteLayer')
/**
 * favourite-layer module implementation.
 */
export class FavouriteLayer extends TerrificSpec {
	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		const $ctx = $(this._ctx);

		$(`.${classes.closeButton}`, $ctx).on('click', this.hideLayer.bind(this));
		
		this.showLayer();

		resolve();
	}

	/**
	 * method hides cookiebar
	 *
	 * @returns {void}
	 */
	hideLayer() {
		Overlays.CloseOverlay(() => $(this._ctx).removeClass(classes.activeClass));
	}

	/**
	 * method hides cookiebar
	 *
	 * @returns {void}
	 */
	showLayer() {
		Overlays.ShowOverlay(() => $(this._ctx).addClass(classes.activeClass), 0);
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() { }
}
